var NewsOnPdp = (function () {

    function init() {

        var pdpNewsContainer = $(".extended-news-list-container.news-list-container").first();
        if (!pdpNewsContainer.length) {
            return;
        }

        $(".extended-news-list-container.news-list-container a").on("click", function () {
            return false;
        });

        $("button.extended-news-list-item-link.more-btn").on("click touchstart", function () {
            var moreBtn = $(this);
            moreBtn.siblings(".extended-news-list-item-preview").hide();
            moreBtn.siblings(".extended-news-details-content").removeClass("hidden");
            moreBtn.siblings(".extended-news-list-item-link.less-btn").toggle();
            moreBtn.toggle();
            return false;
        });

        $("button.extended-news-list-item-link.less-btn").on("click touchstart", function () {
            var lessBtn = $(this);
            lessBtn.siblings(".extended-news-list-item-preview").show();
            lessBtn.siblings(".extended-news-details-content").addClass("hidden");
            lessBtn.siblings(".extended-news-list-item-link.more-btn").toggle();
            lessBtn.toggle();
            return false;
        });
    }

    function hideNews() {
        var pdpNewsContainer = $(".extended-news-list-container.news-list-container");
        if (!pdpNewsContainer.length) {
            return;
        }
        pdpNewsContainer.hide();
    }

    function showNews() {
        var pdpNewsContainer = $(".extended-news-list-container.news-list-container");
        if (!pdpNewsContainer.length) {
            return;
        }
        pdpNewsContainer.show();
    }

    return {
        init: init,
        hideNews: hideNews,
        showNews: showNews
    }
})();

$(function () {
    NewsOnPdp.init();
});